module.exports = require("case-sensitive-paths-webpack-plugin");